import React from "react";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";
import { DRYBULK_CARGO_OPS_ACCESS_PERMISSION } from "@features/drybulk-cargo-operations/constants";
import { isCargoOpsShippingAgentRoles } from "@features/drybulk-cargo-operations/hooks/useIsCargoOpsShippingAgent";
import { cargoOpsAddPath } from "@features/drybulk-cargo-operations/utils/cargoOpsPaths";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { checkPermission } from "@utils/user-permissions";
import { useNavigate } from "react-router-dom";

interface AddCargoOperationFromNominationProps {
  testId: string;
  langBase: string;
  status: string;
  vesselCallId?: string;
  vesselImo?: number | string | null;
}

const AddCargoOperationFromNomination: React.FC<AddCargoOperationFromNominationProps> = ({
  testId,
  langBase,
  status,
  vesselCallId,
  vesselImo,
}) => {
  const navigate = useNavigate();
  const { user, userAccessPermissions } = useAuthStore();
  const available =
    isCargoOpsShippingAgentRoles(user?.roles ?? []) &&
    checkPermission(userAccessPermissions ?? [], DRYBULK_CARGO_OPS_ACCESS_PERMISSION) &&
    status === "APPROVED" &&
    Boolean(vesselCallId) &&
    vesselImo !== undefined &&
    vesselImo !== null;

  return (
    <FlowActionButton
      testId={testId}
      langBase={langBase}
      labelKey="add-from-nomination"
      variant="outlined"
      startIcon={<AddCircleOutline />}
      isActionAvailable={available}
      onClick={() => navigate(cargoOpsAddPath(String(vesselCallId), String(vesselImo)))}
    />
  );
};

export default AddCargoOperationFromNomination;
